<template>
    <div>
        <!-- 商品列表 -->
        <div
            class="goods_list_content"
            :class="[goodslistinfo.goodsliststyle == 1 ? 'A' : 'B']"
            :style="{backgroundColor: type != 0 ? '#fff' : '#F9F9FD'}"
            v-if="listshow">
            <Row :gutter="20">
                <Col
                    class="goods_list_col"
                    ref="goodslistcol"
                    :md="goodslistinfo.goodsliststyle == 1 ? 12 : 24"
                    :lg="goodslistinfo.goodsliststyle == 1 ? 8 : 24"
                    :xl="goodslistinfo.goodsliststyle == 1 ? 6 : 24"
                    :xxl="goodslistinfo.goodsliststyle == 1 ? 4 : 24"
                    v-for="(item, index) in goodslist"
                    :key="index"
                    @mouseenter.native="goodslistEnter"
                    @mouseleave.native="goodslistLeave"
                >
                    <div class="goods_list_box" v-if="item.det.length > 0">
                        <div class="goods_list_img" :style="{backgroundImage: 'url('+item.img+')'}" @click="goto(item.id)">
                            <span v-for="(lab, i) in item.labelids" :key="i" v-show="goodslistinfo.goodsliststyle == 1 && item.labelids != ''">{{lab}}</span>
                        </div>
                        <div class="goods_list_main">
                            <div class="goods_list_title">
                                <span>
                                    <b v-if="item.cxtype == 1" style="background-color: #FF8000">特价</b>
                                    <b v-if="item.cxtype == 2" style="background-color: #40a250">折扣</b>
                                    <b v-if="item.cxtype == 3" style="background-color: #FF8000">促销</b>
                                    <span>{{item.name}}</span>
                                </span>
                            </div>
                            <div class="goods_list_fun_content">
                                <div class="goods_list_price_content">
                                    <div class="goods_list_price_left">
                                        <b>订货价：</b>
                                        <span v-if="item.unitshow && item.cxtype == 0">￥{{(item.mincost * item.matrixing).toFixed(2)}}</span>
                                        <span v-else-if="!item.unitshow && item.cxtype == 0">￥{{item.mincost}}</span>
                                        <span v-else-if="item.unitshow && item.cxtype > 0">￥{{(item.det[0].cxinfo.cxcost * item.matrixing).toFixed(2)}}</span>
                                        <span v-else>￥{{item.det[0].cxinfo.cxcost}}</span>
                                        <b>/{{item.unitshow ? item.maxunit : item.unit}}</b>
                                        <small>市场价{{item.minmcost}}元/{{item.unit}}</small>
                                    </div>
                                    <div class="goods_list_price_right">
                                        <span v-if="outstock <= 0 && item.det[0].stock < item.minordernum && item.is_det == 0">缺货</span>
                                        <div class="goods_list_info" v-else>
                                            <span v-if="stockShow == 2">库存{{item.unitshow ? parseInt((parseInt(item.det[0].stock)/parseInt(item.matrixing))) : item.det[0].stock}}{{item.unitshow ? item.maxunit : item.unit}}</span>
                                            <span>起订{{item.unitshow && item.minorderunit == 'unit' ? (Math.ceil(parseInt(item.minordernum)/parseInt(item.matrixing))) :  item.minordernum}}{{item.unitshow ? item.maxunit : item.unit}}</span>
                                            <span v-if="item.doubleunit == 2">1{{item.maxunit}}={{item.matrixing}}{{item.unit}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="goods_list_manynorms" v-if="item.is_det == 1"><span>{{item.detcount}}规格</span></div>
                                <div class="goods_list_gather_content" :class="{'nohover': item.is_det == 1}">
                                    <div class="goods_list_gather_sign">
                                        <span class="goods_list_number">编号 {{item.commcode}}</span>
                                        <div class="goods_list_gather_box" :style="{justifyContent: item.is_det == 1 ? 'flex-end' : ''}">
                                            <div class="goods_list_num_content" @click.stop v-if="item.is_det == 0 && outstock == 1 || item.is_det == 0 && item.det[0].stock >= item.minordernum">
                                                <div class="goods_list_num">
                                                    <span @click="minBtn(item, item.minorderunit, item.minordernum, item.matrixing)">-</span>
                                                    <div class="goodsnum_select">
                                                        <InputNumber class="goodsnum" v-model="item.num" :min="0" @on-blur="goodsnumBlur(item, item.det[0].cxinfo, item.det[0].stock, item.minorderunit, item.minordernum, item.matrixing, item.maxunit, item.unit)"></InputNumber>
                                                        <i class="icon iconfont icon-xingzhuangjiehe" v-if="item.carcheck"></i>
                                                    </div>
                                                    <span @click="addBtn(item, item.det[0].cxinfo, item.det[0].stock, item.minorderunit, item.minordernum, item.matrixing, item.maxunit, item.unit)">+</span>
                                                </div>
                                                <Tooltip :content="item.unitshow ? item.maxunit : item.unit" theme="light" placement="top">
                                                    <div class="goods_list_unit" :style="{width: item.doubleunit == 1 || item.minorderunit == 'maxunit' ? '23px' : ''}" @click.stop="unitChange(item, item.det[0].cxinfo, item.det[0].stock, item.minorderunit, item.minordernum, item.matrixing, item.maxunit, item.unit, item.doubleunit)">
                                                        <span>{{item.unitshow ? item.maxunit : item.unit}}</span>
                                                        <i class="icon iconfont icon-xialazhankai" v-if="item.doubleunit == 2 && item.minorderunit == 'unit'"></i>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            <div class="goods_list_gwcbtn" v-if="outstock == 1 || item.det[0].stock >= item.minordernum" @click.stop="addGoods(item, index)"><i class="icon iconfont icon-dianliang"></i></div>
                                            <div class="goods_list_gwcbtn" v-else-if="item.is_det == 1" @click.stop="addGoods(item, index)"><i class="icon iconfont icon-dianliang"></i></div>
                                        </div>
                                    </div>
                                    <div class="goods_list_bottom_info">
                                        <span v-if="stockShow == 2">库存
                                            {{item.unitshow ? parseInt((parseInt(item.det[0].stock)/parseInt(item.matrixing))) : item.det[0].stock}}{{item.unitshow ? item.maxunit : item.unit}}
                                        </span>
                                        <div>
                                            <span>起订{{item.unitshow && item.minorderunit == 'unit' ? (Math.ceil(parseInt(item.minordernum)/parseInt(item.matrixing))) :  item.minordernum}}{{item.unitshow ? item.maxunit : item.unit}}</span>
                                            <span v-if="item.doubleunit == 2">1{{item.maxunit}}={{item.matrixing}}{{item.unit}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
        <noMsg v-if="notips"></noMsg>
        <Loadings v-if="loading"></Loadings>
        <!-- 分页 -->
        <div class="page_content" v-if="listshow">
            <Page
                :total="pagetotal"
                :current="pagecurrent"
                :page-size="pagesize"
                :page-size-opts="pagesizeopts"
                show-total
                show-sizer
                show-elevator
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange" />
        </div>
        <!-- 多规格弹窗 -->
        <Modal class="manynorms_popup_content" v-model="manynorms" width="600" @on-cancel="manynormsCancel" v-if="goodslist[goodsActive] != undefined">
            <div slot="header" class="manynorms_popup_header">
                <span>{{goodslist[goodsActive].name}}</span>
            </div>
            <div class="manynorms_popup_body">
                <div class="goods_info_center">
                    <div class="goods_info_list mr10" v-if="goodslist[goodsActive].goodsattr.length >= 2">
                        <span>{{goodslist[goodsActive].goodsattr[0].name}}：</span>
                        <ul>
                            <li :class="[oneActive == index ? 'active' : '']" v-for="(item, index) in goodslist[goodsActive].goodsattr[0].det" :key="index" @click="normsclick(0, index, item.id)">
                                <img :src="item.img" v-if="item.img != ''" />
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="goods_info_list mr10" v-if="goodslist[goodsActive].goodsattr.length >= 3">
                        <span>{{goodslist[goodsActive].goodsattr[1].name}}：</span>
                        <ul>
                            <li :class="[twoActive == index ? 'active' : '']" v-for="(item, index) in goodslist[goodsActive].goodsattr[1].det" :key="index" @click="normsclick(1, index, item.id)">
                                <img :src="item.img" v-if="item.img != ''" />
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="goods_info_norms_content">
                        <div class="goods_info_norms_head">
                            <Row>
                                <Col span="5"><span class="goods_info_norms_txt">型号</span></Col>
                                <Col span="7"><span class="goods_info_norms_txt">订货价</span></Col>
                                <Col span="6" v-if="stockShow == 2"><span class="goods_info_norms_txt">库存</span></Col>
                                <Col span="6">
                                    <span class="goods_info_norms_txt">
                                        起订{{goodslist[goodsActive].minordernum}}{{goodslist[goodsActive].unit}}
                                        <span v-if="goodslist[goodsActive].doubleunit == 2">1{{goodslist[goodsActive].maxunit}}={{goodslist[goodsActive].matrixing}}{{goodslist[goodsActive].unit}}</span>
                                    </span>
                                </Col>
                            </Row>
                        </div>
                        <div
                            class="goods_info_norms_body"
                            v-if="goodslist[goodsActive].goodsattr[(goodslist[goodsActive].goodsattr.length == 1 ? 0 : (goodslist[goodsActive].goodsattr.length == 2 ? 1 : 2))]">
                            <Row
                                class="goods_info_norms_body_list"
                                v-for="(i, iindex) in goodslist[goodsActive].goodsattr[(goodslist[goodsActive].goodsattr.length == 1 ? 0 : (goodslist[goodsActive].goodsattr.length == 2 ? 1 : 2))].det"
                                :key="iindex">
                                <Row
                                    v-for="(j, jindex) in goodslist[goodsActive].det"
                                    :key="jindex"
                                    v-if="(goodslist[goodsActive].goodsattr.length == 1 ? i.id : (goodslist[goodsActive].goodsattr.length == 2 ? tabs1 + ',' + i.id : tabs1 + ',' + tabs2 + ',' + i.id)) == j.gg_ids">
                                    <Col span="5">
                                        <span class="goods_info_norms_txt">
                                            <b v-if="j.cxinfo.type == 1" style="background-color: #FF8000">特价</b>
                                            <b v-if="j.cxinfo.type == 2" style="background-color: #40a250">折扣</b>
                                            <b v-if="j.cxinfo.type == 3" style="background-color: #FF8000">促销</b>
                                            {{i.name}}
                                        </span>
                                    </Col>
                                    <Col span="7">
                                        <span class="goods_info_norms_txt" v-if="j.unitshow && j.cxinfo.is_cx != 1">
                                            ¥{{(j.cost * goodslist[goodsActive].matrixing).toFixed(2)}}/{{j.unitshow ? goodslist[goodsActive].maxunit : goodslist[goodsActive].unit}}
                                        </span>
                                        <span class="goods_info_norms_txt" v-else-if="!j.unitshow && j.cxinfo.is_cx != 1">
                                            ¥{{j.cost}}/{{j.unitshow ? goodslist[goodsActive].maxunit : goodslist[goodsActive].unit}}
                                        </span>
                                        <span class="goods_info_norms_txt" v-else-if="j.unitshow && j.cxinfo.is_cx == 1">
                                            ¥{{(j.cxinfo.cxcost * goodslist[goodsActive].matrixing).toFixed(2)}}<del>（{{j.cost}}）</del>/{{j.unitshow ? goodslist[goodsActive].maxunit : goodslist[goodsActive].unit}}
                                        </span>
                                        <span class="goods_info_norms_txt" v-else>
                                            ¥{{j.cxinfo.cxcost}}<del>（{{j.cost}}）</del>/{{j.unitshow ? goodslist[goodsActive].maxunit : goodslist[goodsActive].unit}}
                                        </span>
                                    </Col>
                                    <Col span="6" v-if="stockShow == 2">
                                        <span class="goods_info_norms_txt">
                                            {{j.unitshow ? parseInt((parseInt(j.stock)/parseInt(goodslist[goodsActive].matrixing))) : j.stock}}{{j.unitshow ? goodslist[goodsActive].maxunit : goodslist[goodsActive].unit}}
                                        </span>
                                    </Col>
                                    <Col span="6">
                                        <div class="goods_list_num_content" v-if="j.stock >= goodslist[goodsActive].minordernum || outstock == 1">
                                            <div class="goods_list_num">
                                                <span @click="minBtn(j, goodslist[goodsActive].minorderunit, goodslist[goodsActive].minordernum, goodslist[goodsActive].matrixing)">-</span>
                                                <div class="goodsnum_select">
                                                    <InputNumber class="goodsnum" v-model="j.num" @on-blur="goodsnumBlur(j, j.cxinfo, j.stock, goodslist[goodsActive].minorderunit, goodslist[goodsActive].minordernum, goodslist[goodsActive].matrixing, goodslist[goodsActive].maxunit, goodslist[goodsActive].unit)"></InputNumber>
                                                    <i class="icon iconfont icon-xingzhuangjiehe" v-if="j.carcheck"></i>
                                                </div>
                                                <span @click="addBtn(j, j.cxinfo, j.stock, goodslist[goodsActive].minorderunit, goodslist[goodsActive].minordernum, goodslist[goodsActive].matrixing, goodslist[goodsActive].maxunit, goodslist[goodsActive].unit)">+</span>
                                            </div>
                                            <Tooltip :content="j.unitshow ? goodslist[goodsActive].maxunit : goodslist[goodsActive].unit" theme="light" placement="top">
                                                <div class="goods_list_unit"
                                                    :style="{width: goodslist[goodsActive].doubleunit == 1 || goodslist[goodsActive].minorderunit == 'maxunit' ? '23px' : ''}"
                                                    @click.stop="unitChange(j, j.cxinfo, j.stock, goodslist[goodsActive].minorderunit, goodslist[goodsActive].minordernum, goodslist[goodsActive].matrixing, goodslist[goodsActive].maxunit, goodslist[goodsActive].unit)"
                                                >
                                                    <span>{{j.unitshow ? goodslist[goodsActive].maxunit : goodslist[goodsActive].unit}}</span>
                                                    <i class="icon iconfont icon-xialazhankai" v-if="goodslist[goodsActive].doubleunit == 2 && goodslist[goodsActive].minorderunit == 'unit'"></i>
                                                </div>
                                            </Tooltip>
                                        </div>
                                        <span class="goods_info_norms_txt" v-else>缺货</span>
                                    </Col>
                                </Row>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="manynorms_popup_footer">
                <Button type="warning" size="large" @click="addGoodsSpecs(goodslist[goodsActive], goodsActive)">加入购物车</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import api from '@/request/api.js'
import noMsg from '@/components/component/nomsg.vue'
import Loadings from '@/components/component/loading.vue'
import {add, min, unitChange, numBlur} from '@/assets/js/addcart.js'
export default {
    props: ['type', 'goodslistinfo'],
    components: {noMsg, Loadings},
    data() {
        return {
            loading: false, // 加载中
            listshow: false, // 列表是否显示
            notips: false, // 暂无提示
            manynorms: false, // 多规格选择商品弹窗 是否打开
            stockShow: 0, // 是否显示库存 1 不显示 2 显示
            outstock: 0, // 是否允许超库存购买 1 允许客户购买下单
            banorder: {}, // 是否禁止下单 error msg
            goodslist: [], // 商品列表
            goodsActive: 0, // 当前选中商品
            normsId: [], // 规格id
            oneActive: 0, // 多规格 --- 第一个分类当前选中
            twoActive: 0, // 多规格 --- 第二个分类当前选中
            goodsid: '',
            tabs1: '',
            tabs2: '',
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getGoodsList () { // 获取商品列表&商品分页（商品列表页面使用）
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.goodslist,
                {
                    catid: this.goodslistinfo.catid,
                    brandid: this.goodslistinfo.brandid,
                    labelids: this.goodslistinfo.labelids,
                    searchtype: this.goodslistinfo.searchtype,
                    sortname: this.goodslistinfo.sortname,
                    sortorder: this.goodslistinfo.sortorder,
                    queryname: this.goodslistinfo.queryname,
                    page: this.pagecurrent,
                    pagesize: this.pagesize,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                for (var i = 0; i < response.data.msg.goods_goodslist.length; i++) {
                    if (response.data.msg.goods_goodslist[i].is_det == 0) { // 0 单规格 1 多规格
                        // 初始数量
                        response.data.msg.goods_goodslist[i].num = 0
                        // 初始判断切换大小单位
                        response.data.msg.goods_goodslist[i].minorderunit == 'maxunit' ? response.data.msg.goods_goodslist[i].unitshow = true : response.data.msg.goods_goodslist[i].unitshow = false
                        // 是否加入购物车图标
                        response.data.msg.goods_goodslist[i].carcheck = false
                    } else {
                        for (var j = 0; j < response.data.msg.goods_goodslist[i].det.length; j++) {
                            // 初始数量
                            response.data.msg.goods_goodslist[i].det[j].num = 0
                            response.data.msg.goods_goodslist[i].minorderunit == 'maxunit' ? response.data.msg.goods_goodslist[i].det[j].unitshow = true : response.data.msg.goods_goodslist[i].det[j].unitshow = false
                            // 是否加入购物车图标
                            response.data.msg.goods_goodslist[i].det[j].carcheck = false
                        }
                    }
                }

                for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                    for (var j = 0; j < response.data.msg.goods_goodslist.length; j++) {
                        if (response.data.msg.goods_goodslist[j].det.length > 0) {
                            if (this.$store.state.shopcartlist[i].is_det == 0) { // 0 单规格 1 多规格
                                if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].det[0].gg_id) {
                                    response.data.msg.goods_goodslist[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                                    response.data.msg.goods_goodslist[j].num = this.$store.state.shopcartlist[i].num
                                    // 是否加入购物车图标
                                    response.data.msg.goods_goodslist[j].carcheck = true
                                }
                            } else {
                                for (var k = 0; k < response.data.msg.goods_goodslist[j].det.length; k++) {
                                    if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].det[k].gg_id) {
                                        response.data.msg.goods_goodslist[j].det[k].num = this.$store.state.shopcartlist[i].num
                                        response.data.msg.goods_goodslist[j].det[k].unitshow = this.$store.state.shopcartlist[i].unitshow
                                        // 是否加入购物车图标
                                        response.data.msg.goods_goodslist[j].det[k].carcheck = true
                                    }
                                }
                            }
                        }
                    }
                }
                this.goodslist = response.data.msg.goods_goodslist
                // 是否显示库存
                this.stockShow = response.data.msg.depository_show
                // 是否允许超库存购买
                this.outstock = response.data.msg.depository_dinghuominus
                // 是否禁止购买
                this.banorder = response.data.msg.orderlimit
                // 获取商品分页
                this.pagetotal = response.data.msg.goods_pagecontent.num
                this.loading = false
                response.data.msg.goods_goodslist.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        getCollectionList () { // 获取商品列表&商品分页（收藏的商品）
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.interestinglist,
                {
                    notestype: 2,
                    page: this.pagecurrent,
                    pagesize: this.pagesize,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                for (var i = 0; i < response.data.msg.goods_goodslist.length; i++) {
                    if (response.data.msg.goods_goodslist[i].is_det == 0) { // 0 单规格 1 多规格
                        // 初始数量
                        response.data.msg.goods_goodslist[i].num = 0
                        // 初始判断切换大小单位
                        response.data.msg.goods_goodslist[i].minorderunit == 'maxunit' ? response.data.msg.goods_goodslist[i].unitshow = true : response.data.msg.goods_goodslist[i].unitshow = false
                        // 是否加入购物车图标
                        response.data.msg.goods_goodslist[i].carcheck = false
                    } else {
                        for (var j = 0; j < response.data.msg.goods_goodslist[i].det.length; j++) {
                            // 初始数量
                            response.data.msg.goods_goodslist[i].det[j].num = 0
                            response.data.msg.goods_goodslist[i].minorderunit == 'maxunit' ? response.data.msg.goods_goodslist[i].det[j].unitshow = true : response.data.msg.goods_goodslist[i].det[j].unitshow = false
                            // 是否加入购物车图标
                            response.data.msg.goods_goodslist[i].det[j].carcheck = false
                        }
                    }
                }

                for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                    for (var j = 0; j < response.data.msg.goods_goodslist.length; j++) {
                        if (response.data.msg.goods_goodslist[j].det.length > 0) {
                            if (this.$store.state.shopcartlist[i].is_det == 0) { // 0 单规格 1 多规格
                                if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].det[0].gg_id) {
                                    response.data.msg.goods_goodslist[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                                    response.data.msg.goods_goodslist[j].num = this.$store.state.shopcartlist[i].num
                                    // 是否加入购物车图标
                                    response.data.msg.goods_goodslist[j].carcheck = true
                                }
                            } else {
                                for (var k = 0; k < response.data.msg.goods_goodslist[j].det.length; k++) {
                                    if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].det[k].gg_id) {
                                        response.data.msg.goods_goodslist[j].det[k].num = this.$store.state.shopcartlist[i].num
                                        response.data.msg.goods_goodslist[j].det[k].unitshow = this.$store.state.shopcartlist[i].unitshow
                                        // 是否加入购物车图标
                                        response.data.msg.goods_goodslist[j].det[k].carcheck = true
                                    }
                                }
                            }
                        }
                    }
                }
                this.goodslist = response.data.msg.goods_goodslist
                // 是否显示库存
                this.stockShow = response.data.msg.depository_show
                // 是否允许超库存购买
                this.outstock = response.data.msg.depository_dinghuominus
                // 是否禁止购买
                this.banorder = response.data.msg.orderlimit
                // 获取商品分页
                this.pagetotal = response.data.msg.goods_pagecontent.num
                this.loading = false
                response.data.msg.goods_goodslist.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        getSeenList () { // 获取商品列表&商品分页（看过的商品）
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.interestinglist,
                {
                    notestype: 3,
                    ids: this.$store.state.goodsBrowsingHistory,
                    page: this.pagecurrent,
                    pagesize: this.pagesize,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                
                for (var i = 0; i < response.data.msg.goods_goodslist.length; i++) {
                    if (response.data.msg.goods_goodslist[i].is_det == 0) { // 0 单规格 1 多规格
                        // 初始数量
                        response.data.msg.goods_goodslist[i].num = 0
                        // 初始判断切换大小单位
                        response.data.msg.goods_goodslist[i].minorderunit == 'maxunit' ? response.data.msg.goods_goodslist[i].unitshow = true : response.data.msg.goods_goodslist[i].unitshow = false
                        // 是否加入购物车图标
                        response.data.msg.goods_goodslist[i].carcheck = false
                    } else {
                        for (var j = 0; j < response.data.msg.goods_goodslist[i].det.length; j++) {
                            // 初始数量
                            response.data.msg.goods_goodslist[i].det[j].num = 0
                            response.data.msg.goods_goodslist[i].minorderunit == 'maxunit' ? response.data.msg.goods_goodslist[i].det[j].unitshow = true : response.data.msg.goods_goodslist[i].det[j].unitshow = false
                            // 是否加入购物车图标
                            response.data.msg.goods_goodslist[i].det[j].carcheck = false
                        }
                    }
                }

                for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                    for (var j = 0; j < response.data.msg.goods_goodslist.length; j++) {
                        if (response.data.msg.goods_goodslist[j].det.length > 0) {
                            if (this.$store.state.shopcartlist[i].is_det == 0) { // 0 单规格 1 多规格
                                if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].det[0].gg_id) {
                                    response.data.msg.goods_goodslist[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                                    response.data.msg.goods_goodslist[j].num = this.$store.state.shopcartlist[i].num
                                    // 是否加入购物车图标
                                    response.data.msg.goods_goodslist[j].carcheck = true
                                }
                            } else {
                                for (var k = 0; k < response.data.msg.goods_goodslist[j].det.length; k++) {
                                    if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].det[k].gg_id) {
                                        response.data.msg.goods_goodslist[j].det[k].num = this.$store.state.shopcartlist[i].num
                                        response.data.msg.goods_goodslist[j].det[k].unitshow = this.$store.state.shopcartlist[i].unitshow
                                        // 是否加入购物车图标
                                        response.data.msg.goods_goodslist[j].det[k].carcheck = true
                                    }
                                }
                            }
                        }
                    }
                }
                this.goodslist = response.data.msg.goods_goodslist
                // 是否显示库存
                this.stockShow = response.data.msg.depository_show
                // 是否允许超库存购买
                this.outstock = response.data.msg.depository_dinghuominus
                // 是否禁止购买
                this.banorder = response.data.msg.orderlimit
                // 获取商品分页
                this.pagetotal = response.data.msg.goods_pagecontent.num
                this.loading = false
                response.data.msg.goods_goodslist.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        updatelist () { // 更新商品列表数据
            if (this.type == 0) {
                this.getGoodsList()
            } else if (this.type == 1) {
                this.getCollectionList()
            } else if (this.type == 2) {
                this.getSeenList()
            }
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.updatelist()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.updatelist()
        },
        goto (id) { // 跳转详情页
            this.http.post(api.checkgoods, {id: id})
            .then(response => {
                this.$router.push({
                    name: '商品详情',
                    params: {
                        id: id
                    }
                })
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        getNormsId (e) { // 获取选择后的规格id
            this.normsId = e
        },
        goodslistEnter () {
            // console.log('移入')
        },
        goodslistLeave () {
            // console.log('移出')
        },
        minBtn (item, minorderunit, minordernum, matrixing) { // 减数量
            item.num = min(item, minorderunit, minordernum, matrixing)
        },
        addBtn (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit) { // 加数量
            item.num = add(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        goodsnumBlur (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit) { // 输入数量
            item.num = numBlur(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit) { // 切换大小规格
            let params = unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit, this.outstock)
            item.unitshow = params.unitshows
            item.num = params.nums
        },
        addGoods (item, index) { // 添加商品到购物车
            if (!this.banorder.error) { // 判断orderlimit.error是否限制下单
                if (item.is_det == 0) { // 判断商品是单规格还是多规格 0 单规格 1 多规格
                    this.addtocart(item)
                } else {
                    this.goodsActive = index
                    this.manynorms = true
                    
                    if (item.goodsattr.length == 1) {
                        this.goodsid = item.goodsattr[0].det[0].id + ''
                    } else if (item.goodsattr.length == 2) {
                        this.goodsid = item.goodsattr[0].det[0].id + ',' + item.goodsattr[1].det[0].id
                        this.tabs1 = item.goodsattr[0].det[0].id
                    } else if (item.goodsattr.length == 3) {
                        this.goodsid = item.goodsattr[0].det[0].id + ',' + item.goodsattr[1].det[0].id + ',' + item.goodsattr[2].id
                        this.tabs1 = item.goodsattr[0].det[0].id
                        this.tabs2 = item.goodsattr[1].det[0].id
                    }
                }
            } else {
                // 弹出提示-限制原因
                this.$Message.warning(this.banorder.msg)
            }
        },
        addtocart (item) { // 商品加入购物车判断条件
            if (item.is_det == 0) { // 判断商品是单规格还是多规格 0 单规格 1 多规格
                if (item.num > 0) { // 判断num是否为0
                    this.inspect(item)
                } else { // 判断num是否为0
                    this.$Message.warning('购买数量不能为0')
                }
            } else {
                for (var i = 0; i < item.det.length; i++) {
                    if (item.det[i].num > 0) {
                        this.inspect(item)
                        break
                    } else if (i == item.det.length-1) {
                        this.$Message.warning('购买数量不能为0')
                    }
                }
            }
        },
        inspect (item) { // 添加购物车时，判断产品是否失效
            let ggidarr = []
            let goodnumarr = []
            let unitshowarr = []
            let newItem = [] // 添加到购物车的字段
            if (item.is_det == 0) { // 判断商品是单规格还是多规格 0 单规格 1 多规格
                newItem.push({
                    gg_id: item.det[0].gg_id, // 规格id
                    id: item.id, // 商品id
                    is_det: item.is_det, // 0 单规格 1 多规格
                    num: item.num, // 商品数量
                    unitshow: item.unitshow, // 大小单位切换 false 小 true 大
                    remarks: '', // 备注信息
                })
            } else {
                for (var i = 0; i < item.det.length; i++) {
                    if (item.det[i].num > 0) {
                        newItem.push({
                            gg_id: item.det[i].gg_id, // 规格id
                            id: item.id, // 商品id
                            is_det: item.is_det, // 0 单规格 1 多规格
                            num: item.det[i].num, // 商品数量
                            unitshow: item.det[i].unitshow, // 大小单位切换 false 小 true 大
                            remarks: '', // 备注信息
                        })
                    }
                }
            }
            for (var i = 0; i < newItem.length; i++) {
                ggidarr.push(newItem[i].gg_id)
                goodnumarr.push(newItem[i].num)
                unitshowarr.push(newItem[i].unitshow)
            }
            this.http.post(api.goodscheck,
                {
                    gid: ggidarr.join(','),
                    goodnum: goodnumarr.join(','),
                    unitshow: unitshowarr.join(','),
                }
            )
            .then(response => {
                console.log(response.data.msg)
                // 添加id购物车到缓存
                this.$store.dispatch('addShopCartList', newItem)
                // 添加成功提示
                this.$Message.success('添加购物车成功')
                // 已添加购物车标志
                item.carcheck = true
                // 多规格弹窗添加成功之后隐藏
                this.manynorms = false
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        normsclick (sign, index, id) { // 多规格弹窗 点击切换商品规格 sign 如果norms大于1条 表示第一行的
            let arr = []
            arr = this.goodsid.split(',')
            if (sign == 0) {
                this.oneActive = index
                arr[0] = this.tabs1 = id
            } else if (sign == 1) {
                this.twoActive = index
                arr[1] = this.tabs2 = id
            }
            this.goodsid = arr.join(',')
        },
        manynormsCancel () { // 关闭多规格弹窗
            this.oneActive = 0
            this.twoActive = 0
        },
        addGoodsSpecs (item, index) { // 多规格商品添加购物车
            this.addtocart(item)
        },
    },
    created () {
        if (this.type == 0) {
            this.getGoodsList()
        } else if (this.type == 1) {
            this.getCollectionList()
        } else if (this.type == 2) {
            this.getSeenList()
        }
    }
}
</script>

<style scoped>

.goods_list_content.A {
    padding-bottom: 6px;
}

.goods_list_content.A .goods_list_price_left > b:first-child,
.goods_list_content.A .goods_list_price_left > small,
.goods_list_content.A .goods_list_info,
.goods_list_content.A .goods_list_number {
    display: none;
}

.goods_list_content.A .goods_list_img {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    font-size: 0;
    position: relative;
    background-color: #fff;
    background-position: center;
    background-size: cover;
    border: 1px solid transparent;
    cursor: pointer;
}

.goods_list_content.A .goods_list_img > span {
    padding: 2px 10px;
    margin: 0 4px 4px 0;
    font-size: 12px;
    color: #fff;
    display: inline-block;
    border-radius: 2px;
}

.goods_list_content.A .goods_list_img > span:nth-child(1) {
    background-color: #698ADF;
}

.goods_list_content.A .goods_list_img > span:nth-child(2) {
    background-color: #FF3333;
}

.goods_list_content.A .goods_list_img > span:nth-child(3) {
    background-color: #EB933B;
}

.goods_list_content.A .goods_list_img > span:nth-child(4) {
    background-color: #AD64CC;
}

.goods_list_content.A .goods_list_img > span:nth-child(5) {
    background-color: #F1CA5C;
}

.goods_list_content.A .goods_list_img > span:nth-child(6) {
    background-color: #29C7B0;
}

.goods_list_content.A .goods_list_main {
    height: 120px;
    padding: 0 8px 10px;
    margin-bottom: 14px;
    transition: height .2s;
    background-color: #fff;
    border: 1px solid transparent;
}

.goods_list_content.A .goods_list_col:hover .goods_list_img {
    border-top-color: #FF8000;
    border-left-color: #FF8000;
    border-right-color: #FF8000;
}

.goods_list_content.A .goods_list_col:hover .goods_list_main {
    border-left-color: #FF8000;
    border-right-color: #FF8000;
    border-bottom-color: #FF8000;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
}

.goods_list_content.A .goods_list_title {
    padding-top: 7px;
}

.goods_list_content.A .goods_list_title > span > b {
    padding: 1px 6px;
    margin-right: 10px;
    font-size: 12px;
    color: #fff;
    font-weight: normal;
    background-color: #FF8000;
    border-radius: 2px;
}

.goods_list_content.A .goods_list_title > span {
    font-size: 14px;
    color: #666;
    text-overflow: ellipsis;
    /*! autoprefixer: off */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    /* autoprefixer: on */ 
    overflow: hidden;
}

.goods_list_content.A .goods_list_fun_content {
    display: flex;
    flex-direction: column;
    position: relative;
}

.goods_list_content.A .goods_list_gather_content {
    height: 0;
    padding: 0 8px 7px;
    padding-top: 2px;
    margin-left: -1px;
    margin-right: -1px;
    background-color: #fff;
    transition: height .2s;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    border-bottom: 1px solid transparent;
    position: absolute;
    left: -8px;
    right: -8px;
    top: 36px;
    z-index: 1;
}

.goods_list_content.A .goods_list_col:hover .goods_list_gather_content {
    height: auto;
    border-left-color: #FF8000;
    border-right-color: #FF8000;
    border-bottom-color: #FF8000;
    box-shadow: 0 5px 6px rgba(0, 0, 0, 0.05);
}

.goods_list_content.A .goods_list_col:hover .goods_list_gather_content.nohover {
    /* height: 0; */
    margin-left: -1px;
    margin-right: -1px;
    box-shadow: none;
    border-left: 1px solid #FF8000;
    border-right: 1px solid #FF8000;
    border-bottom: 1px solid #FF8000;
}

.goods_list_content.A .goods_list_col:hover .nohover .goods_list_num_content {
    opacity: 0;
}

.goods_list_content.A .goods_list_gather_box {
    flex-grow: 1;
    flex-shrink: 1;
    padding-top: 2px;
}

.goods_list_content.A .goods_list_gwcbtn {
    top: -28px;
}

.goods_list_content.A .goods_list_col:hover .goods_list_gwcbtn {
    top: 0;
}

.goods_list_content.A .goods_list_col:hover .nohover .goods_list_gwcbtn {
    top: -28px;
}

.goods_list_content.A .goods_list_num_content,
.goods_list_content.A .goods_list_bottom_info,
.goods_list_content.A .goods_list_col:hover .nohover .goods_list_num_content,
.goods_list_content.A .goods_list_col:hover .nohover .goods_list_bottom_info {
    opacity: 0;
}

.goods_list_content.A .goods_list_col:hover .goods_list_num_content,
.goods_list_content.A .goods_list_col:hover .goods_list_bottom_info {
    opacity: 1;
}

.goods_list_content.A .goods_list_manynorms {
    width: 50%;
    padding-top: 4px;
    position: relative;
    z-index: 2;
}

.goods_list_content.A .goods_list_manynorms > span {
    font-size: 14px;
    color: #999;
}

.manynorms_popup_header > span {
    font-size: 14px;
    color: #0C1F6D;
}

.manynorms_popup_body {
    max-height: 460px;
    padding: 0 20px;
    margin: 0 -16px;
    overflow: auto;
}

.manynorms_popup_footer {
    text-align: center;
}

</style>


// WEBPACK FOOTER //
// src/components/views/goods/goodslist.vue